import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import "./IndustrySelector.css";
import flashMessage from '../HelperFunctions';
import { SUPPORTED_INDUSTRIES } from '../../utils/industries';


function IndustrySelector({ organization, onChange }) {
  const [selectedIndustry, setSelectedIndustry] = useState('healthcare');

  useEffect(() => {

    if (organization && organization.industry) {
      setSelectedIndustry(organization.industry);
    }

  }, [organization?.industry]);


  const handleIndustryChange = async (e) => {
    const selectedIndustry = e.target.value;
    setSelectedIndustry(e.target.value);
    onChange(selectedIndustry);

  }


  return (
    <div>

      <div className="customize-ai-section" style={{ width: 300 }}>
        <span>Select Industry</span>
        <select data-say-id="knowledge-base-industry" className="industry-selector" value={selectedIndustry} onChange={handleIndustryChange}>
        {SUPPORTED_INDUSTRIES.map(industry => (
          <option key={industry.value} value={industry.value}>{industry.label}</option>
        ))}
      </select>
      </div>


    </div>
  );
}

export default IndustrySelector;
